export const hasShippingPackDue = (job) => String(job?.PackDue ?? '').trim() !== '';
